import { useState } from 'react';
import type { Source } from '../lib/types';

// A curated answer is only as good as who typed it and how long ago. Website
// chunks are refreshed by every scrape and self-correct; curated ones never do,
// so the age is shown rather than hidden.
function provenance(s: Source): string | null {
  if (!s.createdBy) return null;
  const when = s.createdAt
    ? new Date(s.createdAt).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' })
    : null;
  return when ? `${s.createdBy} · ${when}` : s.createdBy;
}

export function Sources({ sources }: { sources: Source[] }) {
  const [open, setOpen] = useState(false);
  if (!sources?.length) return null;

  const labels = Array.from(new Set(sources.map((s) => s.label))).join(', ');

  return (
    <div className="sources">
      <button className="sources-toggle" onClick={() => setOpen((o) => !o)}>
        {open ? '▾' : '▸'} Bronnen ({sources.length}: {labels})
      </button>
      {open && (
        <ul className="sources-list">
          {sources.map((s, i) => (
            <li key={`${s.ref}-${i}`}>
              <span className={`source-tag source-${s.source}`}>{s.label}</span>
              {s.title ? <strong> {s.title}</strong> : null}
              {provenance(s) && <span className="source-by"> {provenance(s)}</span>}
              <div className="source-snippet">{s.snippet}…</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
